export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9257.b5188005.jpg";